import { Injectable } from '@angular/core';
import { ActivatedRoute, ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { CommonDataService } from './common-data.service';
import { LoginService } from './Login.service';
import { SessionService } from './Session.service';
import { MatDialog } from '@angular/material/dialog';


@Injectable()
export class RouteGaurdService implements CanActivate {
  constructor(private router: Router, private _loginService: LoginService, private commonservice: CommonDataService, private activatedRoute: ActivatedRoute, private session: SessionService, public commonDataService: CommonDataService, public dialog: MatDialog) { }  activate: boolean = true;
  async canActivate(route: ActivatedRouteSnapshot): Promise<boolean> {
    if (this.session.userInfo == undefined || this.session.userInfo == null || this.session.userInfo.user == null) {
      await this._loginService.getSession().toPromise().then(data => {
        if (data != undefined && data != null && data.user != null && (!this.router.url.includes("Login"))) {
          this.session.assignUserInfo(data.user);
          this.checkSession()
          localStorage.removeItem("DeepLinkRoute");
        }
        else {
          localStorage.setItem("DeepLinkRoute", route.url.map(x => x.path).join("/"));
          let obj = {
            type: 'error',
            displayTime: 3000,
            position: 'bottom',
            message: "You are not authorized , please log in"
          }
          this.commonservice.notificationObject.next(obj);
          this.activate = false;
          this.router.navigate(['Login'])

        }
      });
    }
    else {
      localStorage.removeItem("DeepLinkRoute");
      this.activate = this.checkSession()
    }
    return this.activate

  }
  checkSession() {
    if (this.session.userInfo != null && this.session.userInfo.user != null && ((this.session.userInfo.user.roles == "Basic") || (this.session.userInfo.user.email != "" && this.session.userInfo.user.roles != "Basic"))) {
      localStorage.setItem("showLoginValidation", "true");
      this.activate = true;
    }
    else {
      if (this.session.userInfo.user == null || this.session.userInfo.user.roles == "null") {
        this.activate = false;
      }
      else {
        this.router.navigate(['Login'])
        this.activate = false;
      }
    }
    return this.activate
  }
}
